import { render, staticRenderFns } from "./Law.vue?vue&type=template&id=a1a92fd0&scoped=true&"
import script from "./Law.vue?vue&type=script&lang=ts&"
export * from "./Law.vue?vue&type=script&lang=ts&"
import style0 from "./Law.vue?vue&type=style&index=0&id=a1a92fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a92fd0",
  null
  
)

export default component.exports